<div *ngIf="!harTilgang && !loadingData">
    <i>Du har ikke tilgang til</i>
    <h3>
     {{overskrift}}
    </h3>
</div>